import BrandMarquee from "./BrandMarquee"
import styles from "./RereservationIncentiveBanner.module.scss"

import giftIcon from "@/public/images/incentive_icons/gift.svg"
import { toStringWithCommas } from "@/utils/strings/number"

type Props = {
	price: number
	cancelId: string
	customerName: string
	originPrice: number
	// GIFT_CANDIDATE (予算ありギフト) のとき true。見た目は GIFT と同じにしたうえで、
	// バッジを「確保中」→「数量限定」にし、注意書きに「予算に達し次第終了」の 1 行を足す (biz 指示 2026-11-03)
	isBudgetLimited: boolean
}

// GIFT (えらべるPay) バナー。GIFT_CANDIDATE (予算ありギフト) も同じ見た目で出す
// design 参照: frontend/design/public/rereservation.pen Frame rPg4N 内 "Gift Campaign Section" (id: gft4N)
const GiftBanner = ({
	price,
	cancelId,
	customerName,
	originPrice,
	isBudgetLimited,
}: Props) => {
	const priceText = toStringWithCommas(price)
	const originPriceText = "¥" + toStringWithCommas(originPrice)
	const appliedLabel = `今回 (${priceText}pt 還元)`
	// gift の場合は金額自体は変わらず後日 pt 還元、デザインに合わせて "実質 ¥(origin - price)" を出す
	const effectivePrice = Math.max(0, originPrice - price)
	const appliedValue = "実質 ¥" + toStringWithCommas(effectivePrice)

	return (
		<div className={styles.container}>
			<div className={`${styles.header} ${styles.headerGift}`}>
				<div className={`${styles.headerTitle} ${styles.headerTitleGift}`}>
					<img
						src={giftIcon}
						alt=""
						className={styles.headerIcon}
						aria-hidden="true"
					/>
					<span>{customerName}様 限定</span>
				</div>
				<span className={styles.headerBadge}>
					{isBudgetLimited ? "数量限定" : "確保中"}
				</span>
			</div>

			<div className={styles.mainCard}>
				<div className={styles.mainSubtitle}>
					選べる ¥{priceText} ポイント贈呈
				</div>
				<div className={styles.mainAmountRow}>
					<div className={styles.mainAmount}>{priceText}</div>
					<div className={styles.mainAmountUnit}>ポイント</div>
				</div>
				<div className={styles.mainNote}>
					さまざまなブランドから好きなポイントに交換できます
				</div>
			</div>

			<BrandMarquee />

			<div className={styles.priceRow}>
				<div className={`${styles.priceBox} ${styles.priceBoxNormal}`}>
					<div className={`${styles.priceLabel} ${styles.priceLabelNormal}`}>
						通常メニュー
					</div>
					<div className={`${styles.priceValue} ${styles.priceValueNormal}`}>
						{originPriceText}
					</div>
				</div>
				<span className={styles.priceArrow} aria-hidden="true">
					▶
				</span>
				<div
					className={`${styles.priceBox} ${styles.priceBoxApplied} ${styles.priceBoxAppliedGift}`}
				>
					<div className={`${styles.priceLabel} ${styles.priceLabelApplied}`}>
						{appliedLabel}
					</div>
					<div className={`${styles.priceValue} ${styles.priceValueApplied}`}>
						{appliedValue}
					</div>
				</div>
			</div>

			<div className={styles.cancelIdText}>ギフト番号: {cancelId}</div>

			<div className={styles.notesBox}>
				<div className={styles.notesLine}>・この画面予約経由のみ適応</div>
				<div className={styles.notesLine}>
					・来店ご確認後発行させていただきます
				</div>
				{isBudgetLimited && (
					<div className={styles.notesLine}>・予算に達し次第終了となります</div>
				)}
				<div className={styles.notesLine}>
					※インストール、会員登録は不要です
				</div>
			</div>
		</div>
	)
}

export default GiftBanner
